import { IEnvironmentInfo, IComponentInfo, IPackageInfo, IApplicationInfo, ComponentType } from './app-context.service';
import { PalletTransactions_ModuleContextService } from './PalletTransactions.context.service';

import { Injectable } from '@angular/core';
@Injectable({ providedIn: 'root' })
export class PalletTransactions_pallet_totals_widget_ComponentContextService {
  private readonly moduleContext: PalletTransactions_ModuleContextService;

  constructor(moduleContext: PalletTransactions_ModuleContextService) {
    this.moduleContext = moduleContext;
  }

  public get app(): IApplicationInfo {
    return this.moduleContext.app;
  }

  public get env(): IEnvironmentInfo {
    return this.moduleContext.env;
  }

  public get package(): IPackageInfo {
    return this.moduleContext.package;
  }

  public get component(): IComponentInfo {
    return {
      name: 'pallet_totals_widget',
      type: ComponentType.widget
    }
  }
}